<script lang="ts">
    import Fa from 'svelte-fa'
    import { GridBadge, GridBadgeClassEnum, GridButton, GridClass, GridCol, GridColTypeEnum, GridLine } from '../_common/z/zgrid'
    import { faSync, faEdit, faPlusCircle } from '@fortawesome/free-solid-svg-icons'
    import { Creative } from '../../modules/brokerApi/creatives/creative'
    import { SERVICE, MESSAGE_TYPE } from '../../modules/brokerApi/creatives/creative.enum'
    import { CreativesRepository } from '../../modules/brokerApi/creatives/creatives.repository'
    import { CreativesService } from '../../modules/brokerApi/creatives/creatives.service'
    import type { CreateCreativeDto } from '../../modules/brokerApi/creatives/dto/create-creative.dto'
    import type { UpdateCreativeDto } from '../../modules/brokerApi/creatives/dto/update-creative.dto'
    import Content from '../_common/content.svelte'
    import LoadSpinner from '../_common/load-spinner.svelte'
    import Zgrid from '../_common/z/zgrid.svelte'
    import Zact from '../_common/z/zact.svelte'
    import Zframe from '../_common/z/zframe.svelte'
    import ZContainer from '../_common/z/z-container.svelte'
    import ZinputTitle from '../_common/z/zinput-title.svelte'
    import Zinput from '../_common/z/zinput.svelte'
    import ZContainerRow from '../_common/z/z-container-row.svelte'
    import ZinputBreak from '../_common/z/zinput-break.svelte'
    import type { Channel } from '../../modules/brokerApi/channels/channel'
    import { ChannelType } from '../../modules/brokerApi/channels/channels.enum'
    import Popover from '../_common/popover.svelte'
    import Zbutton from '../_common/z/zbutton.svelte'
    import { onMount } from 'svelte'

    const entityRep = new CreativesRepository()
    const entityS = new CreativesService(entityRep)

    let show = false
    let step = 1
    let entities: Creative[] = []
    let entity: Creative = new Creative()
    let linkToken = ''

    let services = [
        { value: 'wa', label: 'WhatsApp' },
        { value: 'sms', label: 'SMS' },
        { value: 'email', label: 'E-Mail' },
    ]
    let messageTypes = [{ value: 'text', label: 'Texto' }]

    onMount(async () => {
        try {
            show = true
            await loadEntities()
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    })

    async function loadEntities() {
        try {
            show = true
            step = 1
            entities = await entityS.getAll()
            loadGrid()
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    async function editEntity(id: string) {
        try {
            show = true
            if (!wabaOptions?.length) await loadWabaOptions()
            entity = new Creative()
            entity = await entityS.getOne(id)
            console.log('template', entity)
            step = 2
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    async function newEntity() {
        if (!wabaOptions?.length) await loadWabaOptions()
        entity = new Creative()
        entity.messageType = MESSAGE_TYPE.TEXT
        entity.wabaComponents = []
        entity.wabaComponents.push({ type: 'HEADER', format: 'TEXT', text: '' })
        entity.wabaComponents.push({ type: 'BODY', text: '', example: { body_text: [] } })
        step = 2
    }

    async function saveEntity() {
        if (entity.creativeId) {
            updateEntity()
        } else {
            createEntity()
        }
    }

    function validateDto(dto, create: boolean) {
        console.log('dto', dto)
        if (!dto.label) {
            alert('O campo "Nome do template" é obrigatório')
            return false
        }
        if (!dto.service && create) {
            alert('O campo "Tipo de Serviço" é obrigatório')
            return false
        }
        if (entity.service !== SERVICE.WABA) {
            if (!dto.messageType) {
                alert('O campo "Tipo de mensagem" é obrigatório')
                return false
            }
            if (!dto.message) {
                alert('O campo "Mensagem" é obrigatório')
                return false
            }
        } else {
            if (!entity.wabaCategory) {
                alert('O campo "Categoria" é obrigatório para templates de WhatsApp')
                return false
            }
            const bodyComp = entity.wabaComponents.find((c) => c.type === 'BODY')
            if (!bodyComp || !bodyComp.text) {
                alert('O campo "Corpo" é obrigatório para templates de WhatsApp')
                return false
            }
            if (bodyComp.text.length > 500) {
                alert('O campo "Corpo" deve ter no máximo 500 caracteres. Atualmente possui ' + bodyComp.text.length + ' caracteres.')
                return false
            }
            // detecta se tem variável no começo ou fim do corop
            if (/^\{\{.*\}\}/.test(bodyComp.text.trim()) || /\{\{.*\}\}$/.test(bodyComp.text.trim())) {
                alert('Não é permitido ter variáveis no começo ou fim do corpo da mensagem')
                return false
            }
        }
        return true
    }

    async function createEntity() {
        try {
            show = true
            const dto: CreateCreativeDto = {
                label: entity.label,
                message: entity.message,
                messageType: entity.messageType,
                service: entity.service,
                messageCaption: entity.messageCaption,
                wabaCategory: entity.wabaCategory,
                wabaComponents: entity.wabaComponents,
                variables: entity.variables,
                wabaId: entity.wabaId,
                wabaLanguage: 'pt_BR',
                wabaName: sanitizeText(entity.label) + '_' + generateRandomText(3), // o nome do template precisa ser único, então adiciono um sufixo randômico para evitar erros do tipo "já existe um template com esse nome"
            }
            console.log('comp', entity.wabaComponents)
            if (!validateDto(dto, true)) return
            entity = await entityS.create(dto)
            await loadEntities()
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    async function updateEntity() {
        try {
            show = true
            const dto: UpdateCreativeDto = {
                label: entity.label,
                message: entity.message,
                messageType: entity.messageType,
                messageCaption: entity.messageCaption,
                wabaComponents: entity.wabaComponents,
                variables: entity.variables,
                wabaLanguage: 'pt_BR',
            }
            if (!validateDto(dto, false)) return
            await entityS.update(entity.creativeId, dto)
            await loadEntities()
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    async function removeEntity() {
        if (!confirm('Deseja mesmo excluir este item?')) {
            return
        }
        try {
            show = true
            await entityS.remove(entity.creativeId)
            await loadEntities()
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    export function sanitizeText(input: string): string {
        return input
            .normalize('NFD') // separa acentos (ex: "á" -> "a" + "´")
            .replace(/[\u0300-\u036f]/g, '') // remove marcas de acentuação
            .replace(/[^a-zA-Z0-9\s]/g, '') // mantém só letras, números e espaço
            .trim()
            .replace(/\s+/g, '_') // troca espaços (múltiplos) por underscore
            .toLowerCase()
    }
    export function generateRandomText(length: number = 3): string {
        const chars = 'bcdfghjklmnpqrstvwxyz'
        let result = ''

        for (let i = 0; i < length; i++) {
            const randomIndex = Math.floor(Math.random() * chars.length)
            result += chars[randomIndex]
        }

        return result
    }

    function showEntities() {
        step = 1
    }

    function evaluateError(error) {
        window.error(error)
    }

    let grid: GridClass = new GridClass()
    function loadGrid() {
        // grid
        grid = new GridClass()
        // grid head
        grid.title = 'Templates de Mensagens'
        grid.subtitle = 'Crie sua mensagem apenas uma vez e reutilize em várias automações.'
        grid.cols.push(new GridCol({ content: 'Tipo', size: 1, type: GridColTypeEnum.badge }))
        grid.cols.push(new GridCol({ content: 'Nome do template' }))
        grid.cols.push(new GridCol({ content: 'Data de criação', type: GridColTypeEnum.datetime }))
        grid.cols.push(new GridCol({ content: 'Categoria', type: GridColTypeEnum.badge }))
        grid.cols.push(new GridCol({ content: 'Status' }))
        grid.cols.push(new GridCol({ content: '', type: GridColTypeEnum.button }))
        // grid lines
        for (const item of entities) {
            let btnEdit = new GridButton({
                callback: () => editEntity(item.creativeId),
                icon: faEdit,
                label: 'Editar',
            })

            let line: GridLine = new GridLine()
            line.slots.push({ content: new GridBadge({ label: item.service }) })
            line.slots.push({ content: item.label })
            line.slots.push({ content: item.createdAt })
            line.slots.push({ content: createCategoryBadge(item) })
            line.slots.push({ content: item.wabaStatus?.toLowerCase() })
            line.slots.push({ content: [btnEdit] })
            grid.lines.push(line)
        }
    }

    function createCategoryBadge(item: Creative) {
        if (!item.wabaCategory) return new GridBadge({ label: '-' })
        if (item.wabaCategory == 'MARKETING') return new GridBadge({ class: GridBadgeClassEnum.badge_danger, label: 'marketing' })
        if (item.wabaCategory == 'UTILITY') return new GridBadge({ class: GridBadgeClassEnum.badge_success, label: 'utilidade' })
        if (item.wabaCategory == 'AUTHENTICATION') return new GridBadge({ class: GridBadgeClassEnum.badge_default, label: 'autenticação' })
        return new GridBadge({ label: item.wabaCategory.toLowerCase() })
    }

    let serviceOptions: { label: string; value: string }[] = []
    serviceOptions.push({ label: 'WhatsApp Texto', value: 'wa' })
    serviceOptions.push({ label: 'WhatsApp Template', value: 'waba' })
    serviceOptions.push({ label: 'SMS', value: 'sms' })
    serviceOptions.push({ label: 'E-mail', value: 'email' })

    let messageTypeOptions: { label: string; value: string }[] = []
    messageTypeOptions.push({ label: 'Texto', value: 'text' })

    let categoryOptions: { label: string; value: string }[] = []
    categoryOptions.push({ value: 'UTILITY', label: 'Utilitária (R$0,04 por mensagem)' })
    categoryOptions.push({ value: 'MARKETING', label: 'Marketing (R$0,40 por mensagem)' })

    let wabaOptions: { label: string; value: string }[] = []
    async function loadWabaOptions() {
        //wabaOptions
        const channels: Channel[] = await window.api.brokers.channels.getAll({ updateStatus: false })
        wabaOptions = []
        for (const channel of channels) {
            if (channel.type === ChannelType.waba_user) {
                let option = wabaOptions.find((el) => el.value === channel.credentials?.wabaID)
                if (option) {
                    option.label += ` / ${channel.label}`
                } else {
                    wabaOptions.push({ label: channel.label, value: channel.credentials?.wabaID })
                }
            }
        }
        wabaOptions = wabaOptions
    }

    function detectVariables() {
        // regex que detecta variáveis do tipo {{v1}} ou {{v2}}
        const regex = /\{\{(.*?)\}\}/g
        let match
        if (!entity.variables) entity.variables = []
        let body_text: string[][] = entity.wabaComponents.find((c) => c.type === 'BODY').example.body_text || [[]]
        if (body_text.length === 0) body_text.push([])
        let count = 0
        while ((match = regex.exec(entity.wabaComponents.find((c) => c.type === 'BODY').text)) !== null) {
            count++
        }
        if (body_text[0].length > count) {
            body_text[0].splice(count, body_text[0].length - count)
            entity.variables.splice(count, entity.variables.length - count)
        } else {
            for (let i = body_text[0].length; i < count; i++) {
                body_text[0].push('')
                entity.variables.push('')
            }
        }
        if (body_text[0].length === 0) body_text = []
        entity = entity
    }

    async function syncTemplates() {
        try {
            show = true
            await window.api.brokers.creatives.syncWabaTemplates()
            await loadEntities()
        } catch (error) {
        } finally {
            show = false
        }
    }

    let defaultTemplates: boolean = false
    async function showAddDefaultTemplates() {
        if (!wabaOptions?.length) await loadWabaOptions()
        defaultTemplates = true
    }

    let defaultTemplateWabaId: string = null
    let showDT = false
    async function addDefaultTemplates() {
        if (!defaultTemplateWabaId) {
            window.alert('Informe o destino dos templates')
            return
        }
        try {
            showDT = true
            const result = await window.api.brokers.creatives.addDefaultTemplates(defaultTemplateWabaId)
            window.alert('Os templates foram enviados para o WhatsApp e estão aguardando aprovação. Esse processo pode levar de 5 minutos até 48 horas.')
            await loadEntities()
            addDefaultTemplatesClose()
        } catch (error) {
            window.error(error)
        } finally {
            showDT = false
        }
    }

    function addDefaultTemplatesClose() {
        defaultTemplates = false
        defaultTemplateWabaId = null
    }
</script>

{#if defaultTemplates}
    <LoadSpinner show={showDT}
        >Estamos transmitindo seus templates para o WhatsApp.<br />Este processo pode levar até 1 minuto. Não feche esta tela.</LoadSpinner
    >
    <Popover title="Templates padrão" width="880px" on:close={addDefaultTemplatesClose}>
        <Zframe class="m-4" title="Templates padrão">
            <p>Adicione os templates padrão do Zandu ao seu WhatsApp. Estes templates facilitam o envio de mensagens do Zandu através de seu WhatsApp.</p>
            <ZContainer>
                <Zinput label="Telefones de destino" size={8} type="select" options={wabaOptions} required={true} bind:value={defaultTemplateWabaId}></Zinput>
                <Zbutton grow={true} on:click={addDefaultTemplates} label="Adicionar"></Zbutton>
            </ZContainer>
        </Zframe>
    </Popover>
{/if}

<LoadSpinner {show} delay={0} />
{#if step === 1}
    <Content footer={true}>
        <Zact>
            {#if window.store.token.permissions.marketing.templates.write}
                <button class="btn btn-secondary" on:click={showAddDefaultTemplates}><Fa icon={faPlusCircle} /> Adicionar templates padrão</button>
                <div class="spacer"></div>
                <button class="btn btn-secondary" on:click={syncTemplates}><Fa icon={faSync} /> Sincronizar com o WhatsApp</button>
                <button class="btn btn-primary" on:click={newEntity}><Fa icon={faPlusCircle} /> Novo criativo</button>
            {/if}
        </Zact>
        <Zgrid class="h-space" {grid} />
    </Content>
{/if}
{#if step === 2}
    <Content footer={true}>
        <Zact>
            <button class="btn btn-secondary" on:click={showEntities}>Voltar</button>
            <div class="spacer" />
            {#if entity.creativeId}
                <button class="btn btn-warning" on:click={removeEntity}>Excluir</button>
            {/if}
            <button disabled={!!entity.wabaTemplateId} class="btn btn-primary" on:click={saveEntity}>Salvar</button>
        </Zact>

        <Zframe
            title="Template"
            class="h-space"
            headline={entity.creativeId ? 'Atenção: Não é possível editar um template do WhatsApp. Caso seja necessário crie um novo template.' : ''}
        >
            <ZContainer>
                <ZinputTitle title="Dados Básicos"></ZinputTitle>
                <Zinput disabled={!!entity.creativeId && !!entity.wabaName} label="Nome" size={4} type="text" required={true} bind:value={entity.label}
                ></Zinput>
                <Zinput
                    disabled={!!entity.creativeId}
                    label="Tipo de Serviço"
                    size={4}
                    type="select"
                    options={serviceOptions}
                    required={true}
                    bind:value={entity.service}
                ></Zinput>
                {#if !!entity.service}
                    {#if entity.service !== 'waba'}
                        <ZinputTitle title="Dados da mensagem"></ZinputTitle>
                        <Zinput label="Tipo de mensagem" size={4} type="select" options={messageTypeOptions} required={true} bind:value={entity.messageType}
                        ></Zinput>
                        <Zinput label="Mensagem" size={12} rows={10} type="textarea" required={true} bind:value={entity.message}></Zinput>
                    {:else}
                        <ZinputTitle title="Dados do template"></ZinputTitle>
                        <Zinput
                            disabled={!!entity.creativeId}
                            label="Telefones de destino"
                            size={8}
                            type="select"
                            options={wabaOptions}
                            required={true}
                            bind:value={entity.wabaId}
                        ></Zinput>
                        <Zinput
                            disabled={!!entity.creativeId}
                            label="Categoria"
                            size={4}
                            type="select"
                            options={categoryOptions}
                            required={true}
                            bind:value={entity.wabaCategory}
                            help="Os valores são cobrados pelo WhatsApp diretamente em seu cartão de crédito. O WhatsApp pode reclassificar a categoria de sua mensagem se ele acreditar que você selecionou a categoria errada."
                        ></Zinput>
                        <ZinputBreak></ZinputBreak>
                        {#each entity.wabaComponents as comp}
                            {#if comp.type === 'HEADER'}
                                <Zinput label="Cabeçalho (opcional)" size={12} type="text" required={false} bind:value={comp.text}></Zinput>
                            {/if}
                            {#if comp.type === 'BODY'}
                                <Zinput
                                    label="Corpo (máximo 500 caracteres)"
                                    size={12}
                                    type="textarea"
                                    rows={12}
                                    required={true}
                                    bind:value={comp.text}
                                    on:keyup={detectVariables}
                                ></Zinput>
                                {#if comp.example?.body_text?.length > 0}
                                    {#each comp.example.body_text[0] as ex, index}
                                        <Zinput
                                            label="Variável Zandu para a posição {`{{${index + 1}}}`}"
                                            size={6}
                                            type="text"
                                            required={false}
                                            bind:value={entity.variables[index]}
                                        ></Zinput>
                                        <Zinput label="Exemplo de valor (para análise do WhatsApp)" size={6} type="text" required={false} bind:value={ex}
                                        ></Zinput>
                                    {/each}
                                {/if}
                            {/if}
                        {/each}
                    {/if}
                    <ZContainerRow>
                        <div class="text-muted">
                            {#if entity.service === 'waba'}
                                Para incluir variáveis em seu template utilize o padrão do WhatsApp {`{{}}`}. Ex.: "Olá {`{{1}}`}. Tudo bem?!"<br />
                            {/if}
                            Inclua a chave <span class="code">&#123;agendalink&#125;</span> onde desejar inserir o link de confirmação.
                            <br />Outras chaves também estão disponíveis:
                            <span class="code">&#123;nome&#125;</span>
                            <span class="code">&#123;primeironome&#125;</span>
                            <span class="code">&#123;dataevento&#125;</span>
                            <span class="code">&#123;horaevento&#125;</span>;
                            <span class="code">&#123;agendaonline&#125;</span>
                            <span class="code">&#123;npslink&#125;</span>
                        </div>
                    </ZContainerRow>
                {/if}
            </ZContainer>
        </Zframe>
    </Content>
{/if}
